export default __webpack_public_path__ + "static/media/back-arrow.ec9ee2dc.svg";